export default __webpack_public_path__ + "static/team-member-2-fa3d80e6a423016519c4ca97ab74cc73.png";